export var isNumber = function (value) {
    return (typeof value === 'number' || value instanceof Number) &&
        !Number.isNaN(value);
};
//# sourceMappingURL=isNumber.js.map